import '../scss/index.scss';
import MobileMenu from './components/header';
document.addEventListener('DOMContentLoaded', MobileMenu, false);

